/* import __COLOCATED_TEMPLATE__ from './teammate-avatars.hbs'; */
/* RESPONSIBLE TEAM: team-messenger */
import templateOnlyComponent from '@ember/component/template-only';

interface TeammateAvatarsSignature {
  Args: {
    activeBrand: any;
  };
}

const TeammateAvatarsComponent = templateOnlyComponent<TeammateAvatarsSignature>();
export default TeammateAvatarsComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'MessengerSettings::Styling::TeammateAvatars': typeof TeammateAvatarsComponent;
    'messenger-settings/styling/teammate-avatars': typeof TeammateAvatarsComponent;
  }
}
